"use client";
import React from "react";
import PropTypes from "prop-types";
import NavBar from "./NavBar";

const MenuGeneric = ({ menuItems }) => {
  return <NavBar menuItems={menuItems} />;
};

MenuGeneric.propTypes = {
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      alternativePaths: PropTypes.array,
    })
  ).isRequired,
};

export default MenuGeneric;
